<panel width="650">
	<h1>{{ 'product-plan-settings.panel-title' | translate }}</h1>
	@if (settings === undefined) {
		<skeletons [defaultSkeletons]="5" />
	}
	@else {
		<list-view [selectable]="true">
			<header>{{ 'product-plan-settings.column.name' | translate }}</header>
			<header>{{ 'product-plan-settings.column.type' | translate }}</header>
			<row data-id="{{ setting.id }}" *listData="let setting; from: settings" (action)="selectedSetting = setting" [highlighted]="selectedSetting == setting">
				<column>{{ setting.name }}</column>
				<column>{{ 'enum.product-plan-settings-type.' + settingType[setting.type] | translate }}</column>
			</row>
		</list-view>
	}
	<section>
		<button [loader]="false" [ignoreValidation]="true" (click)="createEmptySetting()">{{ 'product-plan-settings.create.button-text' | translate }}</button>
	</section>
</panel>

@if (selectedSetting) {
<panel width="400">
	<h1>{{ selectedSetting.id ? selectedSetting.name : ('product-plan-setting.create' | translate) }}</h1>
	<section>
		@if (!selectedSetting.id) {
			<custom-select [label]="'product-plan-setting.type' | translate" [selectList]="settingTypeItems" [(value)]="selectedSetting.type" />
		}
		@if (selectedSetting.type) {
			<custom-input [label]="'product-plan-setting.name' | translate" [(value)]="selectedSettingName" [required]="true" />
			@if (selectedSetting.type == settingType.FreeProductPlan) {
				<free-product-plan-setting [(setting)]="freeProductPlanSetting" [tags]="selectListTags" />
			}
			@else if (selectedSetting.type == settingType.KeepExistingProductPlanOnDiscontinuation) {
				<keep-existing-product-plan-on-discontinuation [(setting)]="keepExistingProductPlanOnDiscontinuationSetting" [tags]="selectListTags" />
			}
			@else {
				<custom-select [label]="'product-plan-setting.tag' | translate" [selectList]="selectListTags" [(value)]="this.selectedSetting.data" [required]="true" />
			}
		}
	</section>
	@if (selectedSetting.type) {
		<section>
			<button #upsertButton (click)="upsertSetting()" [label]="(selectedSetting.id ? 'general.save' : 'general.create') | translate"></button>
			@if (selectedSetting.id) {
			<button reject (click)="deleteSetting()" [label]="'general.delete' | translate" [ignoreValidation]="true"></button>
			}
		</section>
	}
</panel>
}
